const returnreason = {
    namespaced: true,
    state: {
        visible: false,

        resolve: null,
        reject: null,

        reason: null,
    },
    mutations: {
        SET_VISIBLE(state, payload) {
            state.visible = payload;
        },
        SET_RESOLVE(state, payload) {
            state.resolve = payload;
        },
        SET_REJECT(state, payload) {
            state.reject = payload;
        },
        SET_REASON(state, payload) {
            state.reason = payload;
        },
    },
    actions: {
        async open({ commit}) {
            commit('SET_REASON', null);
            commit('SET_VISIBLE', true);

            return new Promise((resolve, reject) => {
                commit('SET_RESOLVE', resolve);
                commit('SET_REJECT', reject);
            });
        },
        async ok({ commit, state }) {
            commit('SET_VISIBLE', false);
            state.resolve(state.reason);
        },
        async cancel({ commit, state }) {
            commit('SET_VISIBLE', false);
            state.reject({ message: "Cancelled" });
        },
    },
    getters: {
        isVisible: (s) => s.visible,
        isValid: (s) => s.reason != null,
        getReason: (s) => s.reason,
    }
}

export default returnreason;